/**
 * Czy strona „Najlepsze okazje" już istnieje.
 *
 * ═══ DZIŚ `false` — ŚWIADOMIE ═══
 * Baner na stronie głównej jest gotowy, sama strona jeszcze nie (patrz
 * PLAN_OKAZJE.md). Przy `false` kafelek pokazuje się z plakietką „wkrótce"
 * i NIE jest odnośnikiem — ta sama zasada co przy kafelkach partnerskich:
 * przycisk wyglądający na czynny, który prowadzi na pustą stronę, kosztuje
 * więcej zaufania niż uczciwa zapowiedź.
 *
 * ═══ WŁĄCZONE 2026-08-12 — DECYZJA WŁAŚCICIELA, ŚWIADOMA ═══
 * Strona idzie na produkcję przy trafności ~66% (59,5% z przeglądu plus pięć
 * pozycji odciętych regułą zestawów i odsiewem BMS-ów), czyli PONIŻEJ progu 80%,
 * który sami ustaliliśmy. Właściciel zna tę liczbę i decyduje o publikacji.
 *
 * Co to znaczy praktycznie: mniej więcej co trzecia pozycja może porównywać
 * wariant produktu zamiast tego samego produktu. Strona mówi wprost, jak liczy
 * (mediana z N ofert przy każdej pozycji), więc czytelnik może rachunek
 * sprawdzić — i to jest jedyne, co dziś tę listę broni.
 *
 * Znane, niezałatane klasy błędów: rodzina Mw/Mb/Dw/Db przy modułach AIKO,
 * warianty M/S przy Froniusie, RWS/RWB przy SolarEdge, linie MOD/SPH/WIT
 * przy Growatcie. Wszystkie to nieudana ekstrakcja tokenu, który w kluczu JEST.
 *
 * ═══ POPRZEDNIO: WYŁĄCZONE PO PRZEGLĄDZIE 2026-08-12 ═══
 * Ręczny przegląd 42 pozycji dał **47,6% realnych okazji** przy progu 80%
 * (RAPORT_OKAZJE_PRZEGLAD.md). 18 z 20 fałszywek to błędy grupowania modeli,
 * nie ceny: albo najtańsza oferta jest innym produktem, albo medianę budują
 * oferty innych produktów (bateria porównana z zestawem falownik+bateria).
 *
 * Podniesienie progów tego NIE naprawi i byłoby strojeniem pod ładniejszą listę:
 * fałszywki rozkładają się równomiernie od -10% do -39%, więc próg odcinający
 * je obciąłby też większość prawdziwych okazji. Zmierzone, nie założone.
 *
 * Strona zostaje jako narzędzie WEWNĘTRZNE — jest dziś najskuteczniejszym
 * detektorem błędów grupowania, jaki mamy.
 *
 * ZANIM przestawisz na `true`:
 *   1. trasa `/okazje` istnieje i zwraca listę, a nie pustkę,
 *   2. lista ma z czego powstać także w najgorszym tygodniu (patrz próg
 *      w PLAN_OKAZJE.md — przy zbyt ostrych regułach strona bywa pusta),
 *   3. wiadomo, jak oznaczamy pozycje płatne, jeśli sklepy będą się tam ogłaszać.
 */
export const OKAZJE_DOSTEPNE = true

/** Adres strony z okazjami — w jednym miejscu, bo poza banerem wejdzie też do menu. */
export const ADRES_OKAZJI = '/okazje'

export default OKAZJE_DOSTEPNE
